<template>
<div class="chapter">
<div class="inner_page">
<h1 class="preface-title"><a href="#/toc#toc-preface004">MAPS</a></h1>
<p class="noindent"><a id="pagexiii"></a><a href="#/chapter002#map1">Abyssinia and Sudan</a>
</p>
<p class="noindent"><span href="#/chapter008#map2" title="Link target outside of Sample">The Danakil expedition, 1933–34</span></p>
<p class="noindent"><span href="#/chapter017#map3" title="Link target outside of Sample">The Rub’ al Khali, or Empty Quarter</span></p>
<p class="noindent"><span href="#/chapter018#map4" title="Link target outside of Sample">The marshes of Iraq</span></p>
<p class="noindent"><span href="#/chapter019#map5" title="Link target outside of Sample">Afghanistan and Pakistan</span></p>
<p class="noindent"><span href="#/chapter019#map6" title="Link target outside of Sample">Chitral and Hunza</span></p>
<p class="noindent"><span href="#/chapter019#map7" title="Link target outside of Sample">The Hazarajat and Waziristan</span></p>
<p class="noindent"><span href="#/chapter019#map8" title="Link target outside of Sample">Nuristan and Badakhshan</span></p>
<p class="noindent"><span href="#/chapter022#map9" title="Link target outside of Sample">Iran and Iraq</span></p>
<p class="noindent"><span href="#/chapter022#map10" title="Link target outside of Sample">The Yemen</span></p>
<p class="noindent"><span href="#/chapter022#map11" title="Link target outside of Sample">Kenya</span></p>
<p class="center1"><em>(The marking of international boundaries is not authoritative)</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface004.vue?c2e74a78